export const ru = {
    'today': 'Сегодня',
    'yesterday': 'Вчера',
};
